module.exports = __webpack_public_path__ + "images/30f2fd6e6d0df52ab078d4f049dfd1bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Shell/scenes/Header/img/diabetes_logo.png
// module id = 576
// module chunks = 0